function XIcon() {
  return (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.4845 2.91431H20.3872L14.0457 10.1623L21.506 20.0252H15.6646L11.0895 14.0434L5.85444 20.0252H2.94998L9.73291 12.2726L2.57617 2.91431H8.56586L12.7015 8.38189L17.4845 2.91431ZM16.4659 18.2877H18.0743L7.69189 4.56046H5.96588L16.4659 18.2877Z"
        fill="currentColor"
        fillOpacity="0.65"
      />
    </svg>
  );
}
export default XIcon;
